<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Payment Setups
        <small>Create new payment setup</small>
      </h1>

      <ol class="breadcrumb">
        <li>
          <router-link
            :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{path: '/payment-setups'}">Payment Setups</router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">{{ title }}</h3>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div v-if="error" class="alert alert-danger">
                <a class="close"
                  @click="error = false">
                  &times;
                </a>
                {{ error }}
              </div>

              <div class="form-horizontal">
                <div class="form-group">
                  <label for="methods"
                    class="col-sm-3 control-label">
                    Payment Methods <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      name="methods"
                      id="methods"
                      v-model="form.payment_method"
                      :options="lists.payments">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="setup"
                    class="col-sm-3 control-label">
                    Payment Description <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <textarea
                      v-model="form.description"
                      id="setup-description"
                      name="setup-description"
                      class="form-control"
                      row="6"
                      placeholder="Payment setup description">
                    </textarea>
                  </div>
                </div>

                <div class="form-group">
                  <label for="media"
                    class="col-sm-3 control-label">
                    Media <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="media"
                      name="media"
                      v-model="form.media"
                      :options="lists.medias">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="days"
                    class="col-sm-3 control-label">
                    Active Days <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="days"
                      name="days"
                      v-model="form.days"
                      :options="lists.days">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="date"
                    class="col-sm-3 control-label">
                    Date <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <datepicker
                          id="start_date"
                          name="start_date"
                          wrapper-class="custom-vdp"
                          format="yyyy-MM-dd"
                          :disabled="disabledStartDate"
                          v-model="form.date.start"
                          input-class="form-control">
                        </datepicker>
                      </div>
                      <div class="col-12 col-sm-6">
                        <datepicker
                          id="end_date"
                          name="end_date"
                          wrapper-class="custom-vdp"
                          format="yyyy-MM-dd"
                          :disabled="disabledEndDate"
                          v-model="form.date.end"
                          input-class="form-control">
                        </datepicker>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="time"
                    class="col-sm-3 control-label">
                    Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <vue-timepicker
                          hide-clear-button
                          format="HH:mm:ss"
                          v-model="form.time.start">
                        </vue-timepicker>
                        <!-- <input
                          type="text"
                          class="form-control"
                          id="start_time"
                          placeholder="Start Time"
                          v-model="form.time.start"> -->
                      </div>
                      <div class="col-12 col-sm-6">
                        <vue-timepicker
                          hide-clear-button
                          format="HH:mm:ss"
                          v-model="form.time.end">
                        </vue-timepicker>
                        <!-- <input
                          type="text"
                          class="form-control"
                          id="end_time"
                          placeholder="End Time"
                          v-model="form.time.end"> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="status"
                    class="col-sm-3 control-label">
                    Status
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="status"
                      name="status"
                      v-model="form.is_enabled"
                      :options="lists.statuses">
                    </v-select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button @click="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
          <button @click="submit" class="btn btn-info pull-right" v-else>Update</button>
          <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';
import Common from '@/mixins/Common';

export default {
  mixins: [Common],

  data() {
    return {
      title: 'Create Payment Setup',

      error: null,

      isCreate: false,

      form: {
        created: null,
        id: null,
        payment_method: null,
        days: null,
        description: null,
        is_enabled: 1,
        media: null,

        date: {
          start: null,
          end: null,
        },

        time: {
          start: {
            HH: '00',
            mm: '00',
            ss: '00',
          },
          end: {
            HH: '23',
            mm: '59',
            ss: '59',
          },
        },
      },

      lists: {
        payments: [],

        medias: [
          {
            label: 'Web',
            value: 'web',
          },
          {
            label: 'iOS',
            value: 'ios',
          },
          {
            label: 'Android',
            value: 'android',
          },
        ],

        statuses: [
          {
            label: 'Active',
            value: 1,
          },
          {
            label: 'Inactive',
            value: 0,
          },
        ],

        days: [
          {
            label: 'Mon',
            value: 1,
          },
          {
            label: 'Tue',
            value: 2,
          },
          {
            label: 'Wed',
            value: 3,
          },
          {
            label: 'Thu',
            value: 4,
          },
          {
            label: 'Fri',
            value: 5,
          },
          {
            label: 'Sat',
            value: 6,
          },
          {
            label: 'Sun',
            value: 7,
          },
        ],
      },
    };
  },

  components: {
    Datepicker,
    VueTimepicker,
  },

  computed: {
    disabledStartDate() {
      return {
        to: (this.form.created) ? moment(this.form.created).toDate() : moment().subtract(1, 'days').toDate(),
      };
    },

    disabledEndDate() {
      return {
        to: (this.form.date.start) ? moment(this.form.date.start).toDate() : moment().toDate(),
      };
    },

    fullStartTime() {
      return `${this.form.time.start.HH}:${this.form.time.start.mm}:${this.form.time.start.ss}`;
    },

    fullEndTime() {
      return `${this.form.time.end.HH}:${this.form.time.end.mm}:${this.form.time.end.ss}`;
    },
  },

  methods: {
    initCreate() {
      this.isCreate = true;
      this.fetchMethods();
      this.form.is_enabled = {
        label: 'Active',
        value: 1,
      };
    },

    fetch() {
      return new Promise((resolve, reject) => {
        this.axios.get(`/payments/setup/${this.$route.params.id}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((error) => {
            let message = null;

            if (error.response) {
              message = error.response.data.errors;
            }

            reject(new Error('Failed to fetch data', message));
          });
      });
    },

    fetchMethods() {
      return new Promise((resolve, reject) => {
        this.axios.get('/payments/method')
          .then((response) => {
            const { data } = response.data;
            this.lists.payments = data.map(item => ({ label: item.name, value: item.id }));
            resolve();
          })
          .catch((error) => {
            let message = null;

            if (error.response) {
              message = error.response.data.errors;
            }

            reject(new Error('Failed to fetch methods', message));
          });
      });
    },

    prepareData(data) {
      return new Promise((resolve) => {
        const days = [];
        const medias = [];
        const payments = [];

        data.payment_method.forEach((method) => {
          this.lists.payments.forEach((list) => {
            if (method.id === list.value) {
              payments.push(list);
            }
          });
        });

        data.media.forEach((media) => {
          this.lists.medias.forEach((list) => {
            if (media === list.value) {
              medias.push(list);
            }
          });
        });

        data.days.forEach((day) => {
          this.lists.days.forEach((list) => {
            if (day === list.value) {
              days.push(list);
            }
          });
        });

        let status;
        this.lists.statuses.forEach((item) => {
          if (item.value === data.is_enabled) {
            status = item;
          }
        });

        this.form.created = data.created_at;
        this.form.id = data.id;
        this.form.description = data.description;
        this.form.is_enabled = status;
        this.form.payment_method = payments;
        this.form.days = days;
        this.form.media = medias;

        this.form.date = {
          start: (data.start_date) ? this.parseDate(data.start_date) : null,
          end: (data.end_date) ? this.parseDate(data.end_date) : null,
        };

        const timeStart = (data.start_end_time) ? data.start_end_time[0].start : '00:00:00';
        const timeEnd = (data.start_end_time) ? data.start_end_time[0].end : '23:59:59';

        const timeStartSplit = timeStart.split(':');
        const timeEndSplit = timeEnd.split(':');

        const timeStartFull = {
          HH: timeStartSplit[0] || '00',
          mm: timeStartSplit[1] || '00',
          ss: timeStartSplit[2] || '00',
        };

        const timeEndFull = {
          HH: timeEndSplit[0] || '23',
          mm: timeEndSplit[1] || '59',
          ss: timeEndSplit[2] || '59',
        };

        this.form.time = {
          start: timeStartFull,
          end: timeEndFull,
        };

        resolve();
      });
    },

    async fetchAll() {
      try {
        await this.fetchMethods();
        const data = await this.fetch();
        await this.prepareData(data);
      } catch (e) {
        console.log('Failed to fetch payment setup', e);
      }
    },

    parseDate(date) {
      if (!date) return '';
      return moment(date).format(this.config.date.iso);
    },

    validate() {
      if (!this.form.payment_method || this.form.payment_method.length < 1) {
        this.$swal('Payment method required', 'Please select payment method to continue', 'warning');
        return false;
      }

      if (!this.form.description) {
        this.$swal('Payment description required', 'Please fill payment description to continue', 'warning');
        return false;
      }

      if (!this.form.media || this.form.media.length < 1) {
        this.$swal('Payment media required', 'Please select payment media to continue', 'warning');
        return false;
      }

      if (!this.form.days || this.form.days.length < 1) {
        this.$swal('Payment active days required', 'Please select payment active days to continue', 'warning');
        return false;
      }

      if (!this.form.date.start || !this.form.date.end) {
        this.$swal('Payment dates required', 'Please select payment dates to continue', 'warning');
        return false;
      }

      if (!this.form.time.start || !this.form.time.end) {
        this.$swal('Payment time required', 'Please select payment time to continue', 'warning');
        return false;
      }

      if (!this.form.is_enabled) {
        this.$swal('Payment status required', 'Please select payment status to continue', 'warning');
        return false;
      }

      const startTime = moment(this.fullStartTime, 'HH:mm:ss');
      const endTime = moment(this.fullEndTime, 'HH:mm:ss');

      if (endTime.isBefore(startTime, 'second')) {
        this.$swal(
          'Payment time invalid',
          'Please choose correct end time to continue',
          'warning',
        );
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    update() {
      const payments = this.form.payment_method.map(item => item.value);
      const medias = this.form.media.map(item => item.value);
      const days = this.form.days.map(item => item.value);
      const startEndTime = [{
        start: this.fullStartTime,
        end: this.fullEndTime,
      }];

      const data = {
        id: this.form.id,
        payment_method: JSON.stringify(payments),
        description: this.form.description,
        start_date: this.parseDate(this.form.date.start),
        end_date: this.parseDate(this.form.date.end),
        start_end_time: JSON.stringify(startEndTime),
        days: JSON.stringify(days),
        media: medias.join(),
        is_enabled: parseInt(this.form.is_enabled.value, 10),
      };

      return this.axios.put(`/payments/setup/${this.form.id}`, this.stringify(data))
        .then(() => {
          this.$router.push({
            path: '/payment-setups',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    create() {
      const payments = this.form.payment_method.map(item => item.value);
      const medias = this.form.media.map(item => item.value);
      const days = this.form.days.map(item => item.value);
      const startEndTime = [{
        start: this.fullStartTime,
        end: this.fullEndTime,
      }];

      const data = {
        payment_method: JSON.stringify(payments),
        description: this.form.description,
        start_date: this.parseDate(this.form.date.start),
        end_date: this.parseDate(this.form.date.end),
        start_end_time: JSON.stringify(startEndTime),
        days: JSON.stringify(days),
        media: medias.join(),
        is_enabled: parseInt(this.form.is_enabled.value, 10),
      };

      return this.axios.post('/payments/setup', this.stringify(data))
        .then(() => {
          this.$router.push({
            path: '/payment-setups',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },
  },

  created() {
    if (this.$route.params.page === 'create') {
      this.initCreate();
    } else {
      this.fetchAll();
      this.title = 'Edit Payment Setup';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/setups/Form.vue